import { useSelector } from 'react-redux';
import { selectAccessToken } from '~/store/covenants/selectors.ts';

export const useUserAuthToken = () => useSelector(selectAccessToken);
